export const AsideMenu = [
    // 平台融合二期，去掉入口，改为应用列表中进入
    // {
    //     title: '基本信息',
    //     index: '/platform/profile/user',
    //     grayIcon: './img/profile-user-gray.svg',
    //     activeIcon: './img/profile-user-active.svg',
    // },
    // {
    //     title: '企业信息',
    //     index: '/platform/profile/enterprise',
    //     grayIcon: './img/profile-enterprise-gray.svg',
    //     activeIcon: './img/profile-enterprise-active.svg',
    // },
    {
        // title: '消息中心',
        // index: '/platform/profile/message',
        title: '审核通知',
        index: '/platform/profile/message/audit',
        grayIcon: './img/profile-message-gray.svg',
        activeIcon: './img/profile-message-active.svg',
        // child: [
        //     {
        //         title: '审核通知',
        //         index: '/platform/profile/message/audit',
        //         grayIcon: '',
        //         activeIcon: '',
        //     },
        // ],
    },
];
export const MessageMap = {
    audit: '审核通知',
};

export const ChangeEmailSteps = [
    {
        desc: '修改信息填写',
        buttonMsg: '下一步',
    },
    {
        desc: '邮箱激活',
        buttonMsg: '前往激活',
    },
    {
        desc: '修改成功',
        buttonMsg: '',
    },
];
